import moment from 'moment';
import React, { useCallback, useEffect } from "react";
import { IMG_URL } from '../../config/config';
import { useSelector,useDispatch } from '../../store';
import './BigImage.scss';
import { localUnlike,localLike, getLikes } from './Galeria.Api';
import ImageDetailsEditor from './ImageDetailsEditor';

function BigImage({ onViewerClose, isAdmin, onUpdate, onLikeUpdate }) {
	
	const items = useSelector(state=>state.items)
	const currentItem = useSelector(state=>state.currentItem)
	

	const dispatch = useDispatch();
	const myLikes = getLikes()
	const isLiked = myLikes.find(pid=>currentItem.publicId===pid)
	
	const escFunction = useCallback((event) => {
		if (event.key === "Escape") {
			//Do whatever when esc is pressed
			onViewerClose()
		}
		if (event.key === "ArrowLeft") {
			//Do whatever when esc is pressed
			handlePreviousImage()
		}
		if (event.key === "ArrowLRight") {
			//Do whatever when esc is pressed
			handleNextImage()
		}
		console.log(`event.key`, event.key)
	}, []);
	useEffect(() => {
		document.addEventListener("keydown", escFunction, false);
		return () => {
			document.removeEventListener("keydown", escFunction, false);
		};
	}, [escFunction]);

	function handleLikeUnlike(){
		if(isLiked){
			//unliking
			localUnlike(currentItem.publicId)
			const payload=[{publicId:currentItem.publicId, thumbsUp:-1}]
			onLikeUpdate(payload)
		}else{
			localLike(currentItem.publicId)
			const payload=[{publicId:currentItem.publicId, thumbsUp:1}]
			onLikeUpdate(payload)
		}	
	}

	function handleNextImage(){
		if(items){
			for(let i=0; i<items.length; i++){
				if(items[i].url===currentItem.url){
					const nextI = (i+1)%items.length;
					dispatch({currentItem:items[nextI]})
				}
			}
		}
	}

	function handlePreviousImage(){
		if(items){
			for(let i=0; i<items.length; i++){
				if(items[i].url===currentItem.url){
					const nextI = i===0?items.length-1:i-1;//(i-1)%items.length;
					dispatch({currentItem:items[nextI]})
				}
			}
		}
	}

	const aColors=currentItem?.color?.split(',')
	const isTile = currentItem.tags.split(',').indexOf('tile')>0;
	const backstyle = {}
	if(isTile){
		backstyle.backgroundImage= `url("${IMG_URL + '/raw/' + currentItem.url}")`;
		backstyle.backgroundRepeat= 'repeat'
	}
	return (
		<div className="BigImage" style={{}}>

			<div className='ImageWrapper' style={backstyle}>
				{!isTile&&<img className="big-img" alt={currentItem.tags} loading="lazy" src={IMG_URL + '/raw/' + currentItem.url}
					style={{
						width: (currentItem.width > currentItem.height) ? '100%' : 'auto',
						height: (currentItem.width > currentItem.height) ? 'auto' : '100%',
						maxHeight:Math.floor(currentItem.height*1.5)+'px',
						maxWidth:Math.floor(currentItem.width*1.5)+'px',
					}}
					onClick={onViewerClose} 
					/>}
			</div>
			<div className="pic-info" >
				{/* <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style> */}

				<div className='ImageDetails'>
					
				<div className="colors">
				{aColors.map(clr=>{
					return(<div key={clr} className="swat" style={{backgroundColor:clr}}></div>)
				})}
			</div>
					<label>Tags</label>
					<div className="row minitags">{currentItem?.tags?.split(',').join(', ')}</div>
					
					{(currentItem?.name)&&<><label></label>
					<div className="row name">{currentItem?.name}</div></>}

					{(currentItem?.createdAt)&&<><label>Created at</label>
					<div className="row date">{moment(currentItem?.createdAt).format('YYYY-MM-DD')}</div></>}
					
					{(currentItem?.description)&&<><label>Description:</label>
					<div className="row description">{currentItem?.description}</div></>}


				</div>

				{isAdmin && <ImageDetailsEditor
					update={onUpdate}
					image={currentItem}
					isAdmin={isAdmin}
				/>}


			</div>
			<div className={`heart ${isLiked?'active':''}`} onClick={handleLikeUnlike}>♥</div>
			<div className='LeftArrow' onClick={handlePreviousImage}><div className='arrow'>&lt;</div></div>
			<div className='RightArrow' onClick={handleNextImage}><div className='arrow'>&gt;</div></div>

		</div>
	)
}

export default BigImage


